import React, { useContext, useMemo, useState } from 'react';
const initialValue = [null, () => { }];
const AddingCustomTokenContext = React.createContext(initialValue);
export const useAddingCustomTokenContext = () => useContext(AddingCustomTokenContext);
export const AddingCustomTokenProvider = ({ children }) => {
    const [addingCustomToken, setAddingCustomToken] = useState();
    const contextValue = useMemo(() => [addingCustomToken, setAddingCustomToken], [addingCustomToken]);
    return (React.createElement(AddingCustomTokenContext.Provider, { value: contextValue }, children));
};
